import {createActions} from 'client/framework';

export default createActions(null, [
  'INITIALIZE',
  'RESET_STORE',
  'SAVE_ASSIGNMENT',
  'UPDATE_FIELD'
]);
